import * as React from "react"
import { PortableText } from "@portabletext/react"
import ListItem from "../list-item"
import List from "../list"

const BlockContent = ({ blocks, listColumns }) => {
  const components = {
    block: {
      // Ex. 1: customizing common block types
      h1: ({ children }) => (
        <h1 className="text-4xl font-bold text-navy-500 mb-4">{children}</h1>
      ),
      h2: ({ children }) => (
        <h2 className="text-3xl font-bold text-navy-500 mb-4">{children}</h2>
      ),
      h3: ({ children }) => (
        <h3 className="text-2xl font-bold text-navy-500 mb-4">{children}</h3>
      ),
      h4: ({ children }) => (
        <h4 className="text-xl font-bold text-navy-500 mb-4">{children}</h4>
      ),
      blockquote: ({ children }) => (
        <blockquote
          className={
            "text-lg font-semibold border-l-4 border-navy-500 border-solid pl-4 mb-4"
          }
        >
          {children}
        </blockquote>
      ),
      leadParagraph: ({ children }) => (
        <p
          className={
            "text-xl font-normal first-of-type:font-bold first-of-type:text-navy-500"
          }
        >
          {children}
        </p>
      ),
      normal: ({ children }) => <p>{children}</p>,
    },
    marks: {
      link: ({ children, value }) => {
        const rel = !value.href.startsWith("/")
          ? "noreferrer noopener"
          : undefined
        return (
          <a
            href={value.href}
            rel={rel}
            className={
              "text-navy-500 underline transition duration-500 ease-in-out hover:text-navy-700"
            }
          >
            {children}
          </a>
        )
      },
    },
    list: {
      bullet: ({ children }) => <List columns={listColumns}>{children}</List>,
    },
    listItem: {
      bullet: ({ children }) => <ListItem>{children}</ListItem>,
    },
  }

  return (
    <>
      <PortableText value={blocks} components={components} />
    </>
  )
}

export default BlockContent
